import { editors, testimonials } from "@/mocks/site";

export default function CommunitySection() {
  return (
    <section className="bg-accent-50/50 border-y border-accent-100/70">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="mx-auto max-w-3xl text-center">
          <span className="inline-flex items-center gap-2 rounded-md bg-accent-100 px-2.5 py-1 text-xs font-semibold text-accent-900">
            <i className="ri-group-line" />
            编辑与口碑
          </span>
          <h2 className="mt-4 font-heading text-2xl font-black text-foreground-950 md:text-4xl">
            一群认真选好料的人
          </h2>
          <p className="mt-4 text-sm leading-7 text-foreground-600 md:text-base">
            看料背后的编辑，来自不同的领域，却共享同一份挑剔：
            只把自己也愿意花时间读完的内容，推荐给你。
          </p>
        </div>

        {/* 编辑团队 */}
        <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {editors.map((e) => (
            <div
              key={e.name}
              className="flex flex-col items-center rounded-xl border border-background-200/80 bg-background-50 p-6 text-center transition-colors hover:border-primary-200"
            >
              <span
                className={`flex h-16 w-16 items-center justify-center rounded-full font-heading text-2xl font-bold text-background-50 ${e.color}`}
              >
                {e.avatar}
              </span>
              <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">{e.name}</h3>
              <p className="mt-1 text-xs font-semibold text-primary-600">{e.role}</p>
              <p className="mt-3 text-sm leading-6 text-foreground-600">{e.intro}</p>
            </div>
          ))}
        </div>

        {/* 读者口碑 */}
        <div className="mt-12 grid gap-5 lg:grid-cols-3">
          {testimonials.map((t, i) => (
            <figure
              key={t.name}
              className="relative rounded-xl border border-background-200/80 bg-background-50 p-6"
            >
              <i className="ri-double-quotes-l absolute right-5 top-5 text-3xl text-accent-200" aria-hidden />
              <div className="flex items-center gap-1 text-sm text-accent-500">
                {[0, 1, 2, 3, 4].map((s) => (
                  <i key={s} className="ri-star-fill" />
                ))}
              </div>
              <blockquote className="mt-4 text-sm leading-7 text-foreground-700">
                {t.quote}
              </blockquote>
              <figcaption className="mt-5 flex items-center gap-2.5">
                <span className="flex h-9 w-9 items-center justify-center rounded-full bg-secondary-500 text-sm font-bold text-background-50">
                  {t.name.charAt(0)}
                </span>
                <span>
                  <span className="block text-sm font-semibold text-foreground-950">{t.name}</span>
                  <span className="block text-xs text-foreground-500">{t.meta}</span>
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}